import type { OfficialFeeMonthlyTotal } from "../types";

const MONTH_NAMES = [
  "styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec",
  "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień",
];

/**
 * "2026-09-01" -> "wrzesień 2026". Split on the string rather than parsed through
 * `new Date()`: the bucket is a calendar month, and a Date would drag the browser's
 * time zone into it — one hour of skew renames the whole row to the month before.
 */
export function monthLabel(period: string | null | undefined): string {
  if (!period) return "—";
  const [year, month] = period.split("-");
  const name = MONTH_NAMES[Number(month) - 1];
  return name ? `${name} ${year}` : period;
}

/** Newest month on top — the aggregation returns the buckets oldest-first. */
export function newestFirst(rows: OfficialFeeMonthlyTotal[]): OfficialFeeMonthlyTotal[] {
  return [...rows].sort((a, b) => b.period.localeCompare(a.period));
}

/**
 * The "Razem" row. Summed in GROSZE, because adding złote as floats leaves the
 * total a fraction of a grosz off the sum of the rows above it (0.1 + 0.2 ≠ 0.3),
 * and a total that does not match its own column reads as a bug.
 */
export function totalOfMonths(rows: OfficialFeeMonthlyTotal[]): {
  count: number;
  amount: number;
} {
  let grosze = 0;
  let count = 0;
  for (const row of rows) {
    const parsed = parseFloat(row.amount);
    if (!isNaN(parsed)) grosze += Math.round(parsed * 100);
    count += row.count;
  }
  return { count, amount: grosze / 100 };
}
